import { undoMonthArchive } from "../user/actions";
import {
  UNDO_ARCHIVE_MONTH_FAIL,
  UNDO_ARCHIVE_MONTH_REQUEST,
} from "../user/actionType";
import axios from "./utils/axios";

const fetchUndoArchiveMonth = (id) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: UNDO_ARCHIVE_MONTH_REQUEST });
      const {
        login: { userInfo },
      } = getState();
      const config = {
        headers: {
          "Content-type": "application/json",
          Authorization: `Bearer ${userInfo.token}`,
        },
      };
      const { data } = await axios.put(
        `api/common/month/archive-undo/${id}/`,
        {},
        config
      );
      dispatch(undoMonthArchive(data));
    } catch (error) {
      dispatch({
        type: UNDO_ARCHIVE_MONTH_FAIL,
        payload:
          error.response && error.response.data.details
            ? error.response.data.details
            : error.message,
      });
    }
  };
};
export default fetchUndoArchiveMonth;
